<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i> 评级费用
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<div class="title">评级费用</div>
			<wenben ref='submit' @childvalue='childvalue' :Introduction='Introduction'></wenben>
			<el-button type="primary" @click="saveEdit()">提 交</el-button>
		</div>
	</div>
</template>

<script>
	import wenben from '../../components/wenben.vue'
	import E from 'wangeditor'
	import axios from 'axios'
	import qs from 'qs'
	export default {
		components: {
			wenben
		},
		data() {
			return {
				id: '',
				token: localStorage.getItem('access_token'),
				Introduction: ''
			}
		},
		created() {
			this.getid()
		},
		methods: {
			childvalue(val) {
				console.log(val)
				this.Introduction = val
			},
			saveEdit() {
				this.$refs.submit.syncHTML()
				let data = {
					Id: this.id,
					Introduction: this.Introduction,
					ParentId: 'c67ed277-34ec-4efa-9b8f-86a82a6996a5',
					MenuType: 1,
					Name: '评级费用'
				}
				axios({
					method: 'post',
					url: this.$store.state.pcurl + "UpdateMenu",
					headers: {
						"Authorization": "bearer " + this.token
					},
					data: qs.stringify(data)
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						this.$message({
							message: '评级费用修改成功！',
							type: 'success'
						})
					}
				})
			},
			getid() {
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetMenu",
					headers: {
						"Authorization": "bearer " + this.token
					}
				}).then((res) => {
					console.log(res.data.Data)
					res.data.Data.forEach((x) => {
						if (x.Name == '评级费用') {
							this.id = x.Id
							this.Introduction = x.Introduction
						}
					})
				})
			}
		}
	}
</script>

<style scoped>
	.container {
		padding-top: 0;
	}

	.title {
		width: 100%;
		height: 120px;
		font-size: 36px;
		font-weight: bold;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}
</style>
